exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ukEH4SQ3MTFJt5Do0KvW4,.eV2_j5Myfn2aDXrDvEuHf{display:-webkit-box;display:-ms-flexbox;display:flex}.ukEH4SQ3MTFJt5Do0KvW4{-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] .ukEH4SQ3MTFJt5Do0KvW4{padding-bottom:8px}.If_qBP79C-8pj8070OsRS{font-size:14px;font-weight:600}", ""]);
// Exports
exports.locals = {
	"calloutHeader": "ukEH4SQ3MTFJt5Do0KvW4",
	"header": "eV2_j5Myfn2aDXrDvEuHf",
	"calloutHeaderText": "If_qBP79C-8pj8070OsRS"
};